import {reqWithToken} from './requestHelper';

export async function getAll() {
    return (await reqWithToken('api/menus')).data;
}


export async function insert(insert) {
    return (await reqWithToken('api/menus',{
        method: 'post',
        data: insert
    })).data;
}

export async function remove(menuId) {
    return (await reqWithToken('api/menus/',{
        method: 'delete',
        params: {menuId}
    })).data;
}

export async function update(update) {
    return (await reqWithToken('api/menus',{
        method: 'put',
        data: update
    })).data;
}
